import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ConfimationModalComponent } from '../confimation-modal/confimation-modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constants } from '../Constants';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  searchText = "";
  searchChange: Subject<string> = new Subject<string>();
  private paramSource = new BehaviorSubject(null);
  sharedParam = this.paramSource.asObservable();
  elementEvent = new Subject<any>();
  // elementEvent = new Observable();
  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();
  templateChange: Subject<any> = new Subject<any>();
  templateArray = []
  isUpdateDisabled: boolean; 
  updateRelatedSubject: Subject<any> = new Subject<any>();
  showTemplatePreview = false;
  showTemplatePreviewSubject: Subject<any> = new Subject<any>()

  constructor(
    private _http: HttpClient,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) { 
    this.searchChange.subscribe((value) => {
      this.searchText = value;
    });
    this.updateRelatedSubject.subscribe((val) => {
      this.isUpdateDisabled = true;
    })
  }

  changeSearchText(value) {
    this.searchChange.next(value);
  }

  changeTemplate(obj) {
    this.templateChange.next(obj)
  }

  changeUpdateButton() {
    this.updateRelatedSubject.next(false)
  }

  changeTemplatePreview(val) {
    this.showTemplatePreviewSubject.next(val)
  }

  passData(param: any[]) {
    this.paramSource.next(param);
  }

  updateActionListOrder(requestData) {
    return this._http.put(environment.url + "/actionTypes/reorderOrder", requestData);
  }
  
  updateActionListName(requestData) {
    return this._http.put(environment.url + "/actionTypes", requestData);
  }

  restoreDeletedActionList(requestData) {
    return this._http.put(environment.url + "/actionTypes/deleted/restore", requestData);
  }

  confirmationDialog = (body, callback = () => {}) => {
		const dialogRef = this.dialog.open(ConfimationModalComponent, {
			width: '500px',
			autoFocus  : false,
			data : {
				title : 'Confirm your action',
        body: body
			}
		});
		dialogRef.afterClosed().subscribe(result => {
      if(result){
        callback()
      }
		});
	}

  updateHomeColor(hex) {
    const filterChildren = document.getElementById('sort_form_icon_10_width')["children"];
		for(let i=0; i < filterChildren.length; i++) {
			filterChildren[i]["style"]["stroke"] = hex;
		}
  }

  getPrivileges(role) {
    return this._http.get(environment.url + "/roles/privileges/" + role);
  }

  checkPrivilege(privileges, access) {
    let exists = privileges.indexOf(access);
    if (exists === -1) {
      return false
    }
    return true;
  }

  openSnackBar(message): void {
    this._snackBar.open(message, "Ok", {
      duration: 2000
    });
  }

  getDefaultActionTypes(organizationId) {
    return this._http.get(environment.url + "/actionTypes/default/" + organizationId);
  }

  isFormElementAvailable(element) {
    if(Constants.viewElements.indexOf(element) > -1) {
      return true
    } 
    return false
  }

  getTooltipStatus() {
    if(localStorage.getItem('tooltip_enabled') != undefined) {
      return localStorage.getItem('tooltip_enabled') == "true" ? true : false
    } else {
      return true
    }
  }

  sendAddElementEvent() {
    this.elementEvent.next()
  }

  reciveAddElementEvent() {
    return this.elementEvent.asObservable()
  }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  getUserDetails() {
    return this._http.get(environment.url + "/getUserDetails")
  }

  getAppConfig() {
    return this._http.get(environment.url + "/app-config")
  }

  getSubscriptionDetails() {
    return this._http.get(environment.url + "/organization/subscription/details")
  }

  checkOpenMaterialDialogs(): Boolean {
    if (this.dialog.openDialogs.length > 0) {
      return true;
    }
    return false;
  }
}
